// extracted by mini-css-extract-plugin
export var button = "_dl-4";
export var hasDarkBackground = "_dl-7";
export var hasLightBackground = "_dl-6";
export var iconWrapper = "_dl-0";
export var large = "_dl-2";
export var medium = "_dl-1";
export var small = "_dl-5";
export var xsmall = "_dl-3";